import React, { createContext, useContext, useState } from 'react'

interface IHeaderContext {
  subHeaderText: string
  handleSubHeader: (text: string) => void
}

export const HeaderContext = createContext<IHeaderContext>({
  subHeaderText: '',
  handleSubHeader: () => null,
})

export const HeaderProvider = ({ children }: { children: JSX.Element }) => {
  const [subHeader, setSubHeader] = useState<string>('')

  const handleSubHeader = (subHeader: string) => {
    setSubHeader(subHeader)
  }

  return (
    <HeaderContext.Provider
      value={{
        subHeaderText: subHeader,
        handleSubHeader
      }}
    >
      {children}
    </HeaderContext.Provider>
  )
}

export const useHeaderContext = () => {
  return useContext(HeaderContext)
}
